import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export class ApRangeValidator {
    public static validate(min: number, max: number): (control: AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            return Validators.compose([ApRangeValidator.rangeValidator(min, max)])(control);
        };
    }
    public static rangeValidator(min: number, max: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (!value || isNaN(value)) {
                return null;
            }

            const isValid = Number(value) >= min && Number(value) <= max;

            return isValid ? null : { range: { min, max, value: control.value } };
        };
    }
}
